/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from 'react'
import { useNavigate } from 'react-router-dom';

interface bioProps {
    listProfile: any;
  }

const BioSettings: React.FC<bioProps> = ({ listProfile }) => {
    const navigate = useNavigate();
    const updateBio = () => {
        navigate("/settings/bio-update");
      };
  return (
    <div>
            {listProfile?.chefProfile ? (
                          <div className="short-bio mb-3">
                            <div className="head-line">
                              <h6 className="fw-med mb-0">Short Bio</h6>
                              <a
                                href="#"
                                className="text-link"
                                onClick={updateBio}
                              >
                                Edit
                              </a>
                            </div>
                            <p>
                              <span className="tiny">
                                {listProfile?.chefProfile}
                              </span>
                            </p>
                          </div>
                        ) : (
                          <div className="short-bio mb-3">
                            <a
                              className="empty-wrap"
                              href="#"
                              onClick={updateBio}
                            >
                              Give short bio about yourself & cooking...
                              <i className="material-symbols-outlined">edit</i>
                            </a>
                          </div>
                        )}
    </div>
  )
}

export default BioSettings
